import { ChainId } from '@1inch-community/models';
export function getChainIdList() {
    return Object.values(ChainId).filter((item) => typeof item === 'number');
}
//# sourceMappingURL=chain-id-list.js.map